

/* TRAINING FILTERS
---------------------------------------------------------------------------------------------------- */

import gsap from 'gsap'
import Filters from './Filters'

export default class TrainingFilters extends Filters {

    handleNewResults(html) {
        const { isMobile } = APP.Layout
        const $html = this.parser.parseFromString(html, 'text/html')

        const $currentItems   = Array.from(this.$refs.item)
        const $currentMarquee = this.$refs.marqueeMover

        const $animatableItems      = $currentItems.filter($item => $item.classList.contains('js-stg'))
        const $animatableInnerItems = $animatableItems.map($el => $el.querySelector('.js-Filters-itemInner'))

        const $newItems         = [...$html.querySelectorAll('.js-Filters-item')]
        const $newInnerItems    = $newItems.map($el => $el.querySelector('.js-Filters-itemInner'))
        const $nextMarquee      = $html.querySelector('.js-Filters-marquee')
        const $nextMarqueeMover = $html.querySelectorAll('.js-Filters-marqueeMover')



        const tl = gsap.timeline({
            onStart: () => {
                this.abortFetch()
                $currentItems.forEach($el => this.observer.unobserve($el))
            },

            onComplete: () => {
                this.$refs.item         = $newItems
                this.$refs.marquee      = $nextMarquee
                this.$refs.marqueeMover = $nextMarqueeMover

                this.$refs.item.forEach($item => this.observer.observe($item))
            },
        })

        const newItemsConfig       = isMobile ? { y: -20 } : { scale: 1.05 }
        const animatableItemConfig = isMobile ? { y: 50 } : { scale: 0.9 }

        tl.set($animatableItems, { willChange: 'transform, opacity' })
        tl.set($newItems, { alpha: 0, willChange: 'transform, opacity', ...newItemsConfig })
        tl.set($newInnerItems, { scale: isMobile ? 1 : 1.2, willChange: 'transform, opacity' })
        tl.set($nextMarqueeMover, { yPercent: -100 })

        tl.to($currentMarquee, {
            yPercent: 100,
            duration: 0.5,
            force3D: true,
            ease: 'power2.in',
            stagger: { amount: 0.8 },
        })

        tl.to($animatableItems, {
            alpha: 0,
            duration: 0.6,
            force3D: true,
            ease: 'power2.inOut',
            stagger: { amount: 0.4 },
            ...animatableItemConfig,
        }, '<0.25')


        tl.to($animatableInnerItems, {
            scale: isMobile ? 1 : 0.8,
            duration: 0.6,
            force3D: true,
            ease: 'power2.inOut',
            stagger: { amount: 0.4 },
        }, '<')


        tl.call(() => {
            this.$refs.marqueeCtn.empty()
            this.$refs.list.empty()

            this.$refs.list.append($newItems)
            this.$refs.marqueeCtn.append($nextMarquee)
            this.$utils.doc.trigger('contentChange')
        })


        tl.to($nextMarqueeMover, {
            yPercent: 0,
            duration: 0.5,
            force3D: true,
            ease: 'power2.out',
            stagger: { amount: 0.8 },
            clearProps: true,
        })


        tl.to($newItems, {
            y: 0,
            scale: 1,
            alpha: 1,
            duration: 0.6,
            force3D: true,
            ease: 'power2.inOut',
            stagger: { amount: 0.3 },
            clearProps: true,
        }, '<0.1')


        tl.to($newInnerItems, {
            scale: 1,
            duration: 0.6,
            force3D: true,
            ease: 'power2.inOut',
            stagger: { amount: 0.3 },
            clearProps: true,
        }, '<')
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
